/* eslint-disable max-len */
import React from 'react';
import {
  Container, Row, Col, Button,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
// import moment from 'moment';

import { AsyncTableInfinite, Intl } from 'components';
import { formatNumeral, formatPhone, getCountryName } from 'utils';

const hiddenIsLoading = true;

export default ( {
  payments, phoneNumbers, isLoading, locale, parentPath, onFetchPayments,
  onFetchPhoneNumbers, onDownloadInvoice, onEditPhoneNumber, userData,
} ) => (
  <Container
    fluid
    className={classnames( {
      'app-component-loading': isLoading,
    } )}
  >
    <Row>
      <Col>
        <AsyncTableInfinite
          data={phoneNumbers.data}
          isLoading={isLoading}
          hiddenIsLoading={hiddenIsLoading}
          total={phoneNumbers.total}
          onFetchData={onFetchPhoneNumbers}
          defaultSortBy={[{ id: 'createdAt', desc: true }]}
          titleContent={<Intl id="hiredNumbers" />}
          minRows={6}
          columns={[
            {
              Header: 'number',
              accessor: 'directDial.number',
              id: 'number',
              width: 25,
              Cell: ( { cell } ) => ( cell.value ? formatPhone( cell.value ) : '' ),
              
            },
            {
              Header: 'countryArea',
              accessor: 'directDial',                                          
              id: 'country',
              width: 25,
              Cell: ( { cell } ) => getCountryName( cell.value.country, cell.value.area,locale) +` - ${cell.value.area}`,
            },
            {
              Header: 'amountCurrency',
              accessor: 'directDial.amount',
              id: 'amount',
              width: 25.1,
              Cell: ( { cell } ) => formatNumeral( cell.value ),
            },
            {
              Header: '',
              accessor: 'id',
              width: 25,
              disableSorting: true,
              Cell: ( { cell } ) => (
                <>
                  <Button
                    color="outline-link"
                    className="p-0 lh-110"
                    onClick={() => onEditPhoneNumber( cell.value )}
                  >
                  
                    <Intl id="edit" />
                  </Button>
                </>
              ),
            },
          ]}
          headerWidth={['col', 'col', 'col', 'col']}
          values={{ currency : "(" + userData.currency_symbol + ")" }}
        />
      </Col>
    </Row>
    <Col className="text-sm">
        <Intl id="footNodeOnAdministration" />
        </Col>

    <Row>
      <Col lg={12} className="text-md-right mt-3">
        <p className="m-0 lh-100">
          <Intl id="invoiceOrVatExempt" />
        </p>
        <Link to={`${parentPath}/billing`} className="text-mp-blue-1">
          <Intl id="editFiscalData" />
        </Link>
      </Col>
    </Row>

    <Row className="mt-3">
      <Col>
        <AsyncTableInfinite
          isLoading={isLoading}
          hiddenIsLoading={hiddenIsLoading}
          data={payments.data}
          total={payments.total}
          onFetchData={onFetchPayments}
          defaultSortBy={[{ id: 'createdAt', desc: true }]}
          titleContent={<Intl id="paymentHistory" />}
          minRows={6}
          columns={[
            {
              Header: 'dateAndTime',
              accessor: 'createdAt',
              // Cell: ( { cell } ) => ( cell.value ? moment( Number( cell.value ) ).format( 'YYYY-MM-DD HH:mm' ) : '' ),
              Cell: ( { cell } ) => ( cell.value ?  cell.value  : '' ),
              width: 25,
            },
            {
              
              Header: 'invoiceNo',
              accessor: 'invoiceNo',
              id:"numberInvoice",
              width: 25,
            },
            {
              Header: 'amountCurrency',
              accessor: 'amountWithoutIva',
              id: 'amount',
              Cell: ( { cell } ) => formatNumeral( cell.value ),
              width: 25,
            },
            {
              Header: 'invoice',
              accessor: 'id',
              disableSorting: true,
              width: 25,
              Cell: ( { cell } ) => (
                <>
                  <Button
                    color="outline-link"
                    className="p-0 lh-110"
                    onClick={() => {
                      onDownloadInvoice( cell.value );
                    }}
                  >
                    <Intl id="download" />
                  </Button>
                </>
              ),
            },
          ]}
          values={{ currency : "(" + userData.currency_symbol + ")" }}
          headerWidth={['col', 'col', 'col', 'col']}
        />
      </Col>
    </Row>
    <Col className="text-sm" >
        <Intl id="footNodeOnAdministration" />
        </Col>
  </Container>
);
